import { FunnelIcon } from '~/components/Listing/ListHeader/ListHeaderShards'
import { AllQueryVariables } from '~/components/Listing/ListingPageContent/ListingPageContentTypes'
import { useFERListingQuery } from '~/components/Listing/ListingPageContent/ListingPageContentUtils'
import { getFERListQueryVariables } from '~/components/Listing/pages/FERListingPage/FERListingPageUtils'
import { paths } from '~/constants'
import { FerListQueryVariables, RestaurantsListQuery, useFerListQuery } from '~/generated/graphql'
import { gt } from '~/locale'
import { SelectContainer } from '~/shared/atoms/Select'

import ListingMap from '.'
import { MapButtonWrapper, MapModalWrapper } from './MapShards'
import { MapViewProps } from './MapView'

// not in MapUtils.tsx cuz there is some SSR problem when importing leaflet too early

export const MapModal = ({ items, loading }: MapViewProps) => {
  return (
    <MapModalWrapper>
      <ListingMap items={items} loading={loading} />
    </MapModalWrapper>
  )
}

interface FestivalMapModalProps {
  defaultVariables: FerListQueryVariables
  festivalEditionId: string
}

export const FestivalMapModal = ({ defaultVariables, festivalEditionId }: FestivalMapModalProps) => {
  const { data, loading } = useFERListingQuery({
    getQueryVariables: (filters: AllQueryVariables) => getFERListQueryVariables({ first: 150, festivalEditionId, ...filters }),
    useQueryHook: useFerListQuery,
    defaultVariables,
  })

  const getMapHref = (id: string) => {
    const router = new URL(window.location.href)
    const searchParams = router.searchParams
    searchParams.set('ferId', id)
    return `${router.origin}${router.pathname}?${searchParams.toString()}`
  }

  const transformedItems =
    data?.festivalEditionRestaurants?.nodes?.map((item: any) => ({
      latitude: item.restaurant.latitude,
      longitude: item.restaurant.longitude,
      name: item.restaurant.name,
      description: item.restaurant.address,
      detailsHref: getMapHref(item.id),
    })) || []

  return <MapModal items={transformedItems} loading={loading} />
}

interface D2DMapModalProps {
  restaurantNodes: RestaurantsListQuery['restaurants']['nodes']
  loading: boolean
  isFetchingMore: boolean
}

export const D2DMapModal = ({ restaurantNodes, loading, isFetchingMore }: D2DMapModalProps) => {
  const getMapHref = (restaurantSlug?: string) => {
    return restaurantSlug ? paths.singleRestaurant({ slug: restaurantSlug }) : ''
  }

  const transformedItems =
    restaurantNodes?.map((item: any) => ({
      latitude: item.latitude,
      longitude: item.longitude,
      name: item.name,
      description: item.address,
      detailsHref: getMapHref(item?.slug),
    })) || []

  return <MapModal items={transformedItems} loading={loading || isFetchingMore} />
}

export const MapButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <MapButtonWrapper>
      <SelectContainer
        style={{ width: '100%' }}
        onClick={onClick}
        title={
          <>
            <FunnelIcon active={false} icon='location' />
            {gt.tp('ListingPage', 'View on the map')}
          </>
        }
      />
    </MapButtonWrapper>
  )
}
